export default "__VITE_ASSET__YOn83cW4__"